import lodashGet from 'lodash/get';

import {gt} from 'app/utils/i18n';
import {capitalizeFirstLetter} from 'app/utils/strings';

export function extractErrorMessage(error: any): string | undefined {
  return error != null
    ? // first we try the simpler fields we know can error out
      lodashGet(error, 'non_field_errors[0]') ||
        lodashGet(error, 'name[0]') ||
        lodashGet(error, 'procedure_name[0]') ||
        // ok, nothing found, let's try the steps (content field)
        getContentErrorMessage(error) ||
        // not yet? maybe lanes names then
        getLanesErrorMessage(error)
    : undefined;
}

function getContentErrorMessage(error: any): string | undefined {
  if (error.content) {
    const stepIndex = Object.keys(error.content)[0];
    if (stepIndex !== null) {
      const errorMessage = extractStepErrorMessage(error.content[stepIndex]);
      return gt('Step %s: %s', stepIndex, errorMessage);
    }
  }
}

function extractStepErrorMessage(
  error: void | string | {[field: string | number]: any}
): string {
  if (typeof error === 'string') {
    return error;
  }
  if (error == null) {
    return gt('Unknown Error');
  }

  let fieldName = Object.keys(error)[0];
  let message = error[fieldName];

  if (!isNaN(fieldName as any)) {
    // when fieldName is a number it's the item index, so let's increment it by 1
    // to be human readable
    fieldName = (Number(fieldName) + 1).toString();
  }

  // is it an object?
  if (typeof error !== 'string') {
    message = extractStepErrorMessage(message);
  }
  return `${capitalizeFirstLetter(fieldName)}: ${message}`;
}

function getLanesErrorMessage(error: any): string | undefined {
  const errorLanes: undefined | {[laneId: string]: {name: Array<string>}} =
    lodashGet(error, 'lanes');

  if (errorLanes != null) {
    const fieldError = Object.values(errorLanes)[0];
    if (fieldError.name != null) {
      return gt('Lane name: %s', fieldError.name[0]);
    }
  }
}
